import { DEFAULT_COLUMN_VISIBILITY } from "../constants";

type ColumnVisibility = {
  id: string;
  label: string;
  checked: boolean;
  disabled: boolean;
};

export const mergeColumnsWithDefaults = (
  savedColumns: ColumnVisibility[] | undefined
): ColumnVisibility[] => {
  if (!savedColumns) return DEFAULT_COLUMN_VISIBILITY;

  const mergedColumns = [...savedColumns];

  DEFAULT_COLUMN_VISIBILITY.forEach((defaultCol, index) => {
    if (mergedColumns.some((col) => col.id === defaultCol.id)) return;

    const previousId = DEFAULT_COLUMN_VISIBILITY[index - 1]?.id;
    const previousIndex = mergedColumns.findIndex(
      (col) => col.id === previousId
    );
    mergedColumns.splice(previousIndex + 1, 0, defaultCol);
  });

  return mergedColumns;
};
